import { useParams } from "react-router-dom";
import { useState } from "react";
import "./Booking.css";

function Booking() {
  const { movieId } = useParams();
  const [pincode, setPincode] = useState("");

  const openBookMyShow = () => {
    window.open(
      `https://in.bookmyshow.com/explore/movies?search=${movieId}`,
      "_blank"
    );
  };

  const openPaytm = () => {
    window.open(
      `https://paytm.com/movies`,
      "_blank"
    );
  };

  return (
    <div className="booking-page">
      <h2>🎟 Book Tickets</h2>

      {/* PINCODE */}
      <div className="pincode-box">
        <input
          type="text"
          placeholder="📍 Enter Zip / Pincode"
          value={pincode}
          onChange={(e) => setPincode(e.target.value)}
        />
        <button>Search</button>
      </div>

      {/* THEATRE CARDS */}
      <div className="theatre-list">
        <div className="theatre-card">
          <h4>BookMyShow</h4>
          <button onClick={openBookMyShow}>Book Now</button>
        </div>

        <div className="theatre-card">
          <h4>Paytm Movies</h4>
          <button onClick={openPaytm}>Book Now</button>
        </div>
      </div>
    </div>
  );
}

export default Booking;
